import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const QuotedMessageVideoFileIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M10 5.33333V10.6667H3.33333V5.33333H10ZM10.6667 4H2.66667C2.3 4 2 4.3 2 4.66667V11.3333C2 11.7 2.3 12 2.66667 12H10.6667C11.0333 12 11.3333 11.7 11.3333 11.3333V9L14 11.6667V4.33333L11.3333 7V4.66667C11.3333 4.3 11.0333 4 10.6667 4Z" />
  </Icon>
);

export default memo(QuotedMessageVideoFileIcon);
